import { Box, Typography } from '@mui/material'
import React from 'react'

function Card({children}) {
  return (
   <Box sx={{display:"flex" ,flexDirection:"column",
    bgcolor: "#FF980033",
    border: "1px solid #FF9800",
    borderRadius: "4px",
    padding: "4px 8px",
    margin:"6px 0",
  }}>
    {children}
   </Box>
  )
}

export default Card